export class ExportService {
  constructor(data) {
    this.data = data;
  }

  async putKBOverviewExport({ knowledgeId }) {
    const response = await this.data.putKBOverviewExport({ knowledgeId });
    return response.data
  }
  async getKBOverviewExport({ knowledgeId }) {
    const response = await this.data.getKBOverviewExport({ knowledgeId });
    return response.data
  }
}
